import OrderItem from './orderItem';
import ShipTo from './shipTo';
import ShipToResponse from './shipToResponse';

class Order {
  constructor({
    id,
    attributes: {
      total,
      processed_at,
      subtotal,
      instructions,
      ordered_by,
      order_items,
      ship_to,
      createdAt,
      updatedAt,
    },
  }) {
    this.id = id;
    this.total = total;
    this.processedAt = processed_at;
    this.subtotal = subtotal;
    this.instructions = instructions;
    this.orderedBy = ordered_by;

    if (ship_to) {
      if (typeof ship_to !== 'string') {
        this.shipTo = ship_to?.data
          ? new ShipTo(ship_to.data)
          : new ShipToResponse(ship_to);
      } else {
        this.shipTo = ship_to;
      }
    }

    if (order_items?.data.length > 0) {
      this.orderItems = order_items.data.map((item) => new OrderItem(item));
      if (order_items?.data.length > 1) {
        this.totalItems = order_items.data.reduce(
          (prev, curr) =>
            prev?.attributes?.quantity + curr?.attributes?.quantity,
        );
      } else {
        this.totalItems = order_items.data[0].attributes?.quantity;
      }
    }
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export default Order;
